export default "__VITE_ASSET__kbOvAXYs__"